import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'Text';

function Circle({ completed }: { completed: boolean }) {
    return (
        <div
            className={clsx('flex h-5 w-5 shrink-0 items-center justify-center rounded-full', {
                'bg-primary': completed,
                'bg-slate-grey-200': !completed,
            })}
        >
            {completed && <FontAwesomeIcon className="text-[11px] text-white" icon={faCheck} />}
        </div>
    );
}

function Bar({ completed }: { completed: boolean }) {
    return (
        <div
            className={clsx('shrink-1 flex h-1 w-full rounded-1', {
                'bg-primary': completed,
                'bg-slate-grey-200': !completed,
            })}
        />
    );
}

export function FoundationsProgressComponent({
    foundationsComplete,
    playlistTitle,
}: {
    foundationsComplete: boolean;
    playlistTitle: string;
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'applicationReceivedBox' });

    return (
        <div className="flex w-full flex-col gap-2">
            <div className="flex items-center justify-between gap-[5px]">
                <Circle completed />
                <Bar completed />
                <Circle completed={foundationsComplete} />
                <Bar completed={foundationsComplete} />
                <Circle completed={false} />
            </div>
            <div className="flex items-center justify-between gap-[5px]">
                <Text className="text-2xs" color="primary">
                    {t('applied')}
                </Text>
                <Text className="text-2xs" color={foundationsComplete ? 'primary' : 'slate-grey'}>
                    {playlistTitle}
                </Text>
                <Text className="text-2xs" color="slate-grey">
                    {t('decision')}
                </Text>
            </div>
        </div>
    );
}

export const FoundationsProgress = memo(FoundationsProgressComponent);
